/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import Room from './Room'

/**
 * The InlineResponse20031 model module.
 * @module model/InlineResponse20031
 * @version 1.0.0
 */
export default class InlineResponse20031 {
  /**
   * Constructs a new <code>InlineResponse20031</code>.
   * @alias module:model/InlineResponse20031
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>InlineResponse20031</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20031} obj Optional instance to populate.
   * @return {module:model/InlineResponse20031} The populated <code>InlineResponse20031</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20031()

      if (data.hasOwnProperty('room')) {
        obj['room'] = Room.constructFromObject(data['room'])
      }
    }
    return obj
  }

  /**
   * @member {module:model/Room} room
   */
  room = undefined
}
